import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgActionInput = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="M8 9H4v11h16V9h-4V7h6v15H2V7h6v2Zm4 5.5L9 11h2V2h2v9h2l-3 3.5Z"
    />
  </svg>
);
export default SvgActionInput;
